# Vue
import Vue from 'vue'

# Plugins
import Vuex from 'vuex'
import Vuetify from 'vuetify'
import AsyncComputed from 'vue-async-computed';
import 'moment-timezone'
import 'vuetify/dist/vuetify.min.css'
import VueScrollTo from 'vue-scrollto'
import truncate from 'vue-truncate-collapsed'
import { sync } from 'vuex-router-sync'

import app from './App'
import router from './router/router.coffee'
import store from './store/store.coffee'
import filters from './filters/filters.coffee'
import a11yClick from './directives/a11yClick.coffee'
import a11yThScope from './directives/a11yThScope.coffee'
import a11yHidden from './directives/a11yHidden.coffee'

# Stylesheets
import stylesheet from '@/assets/style.css'
import '../static/fonts/Roboto/Roboto.css'
import '../static/fonts/MaterialIcons/MaterialIcons.css'
import '../static/fonts/FontAwesome4/css/font-awesome.css'
import '@fortawesome/fontawesome-free/css/all.css'

# Component imports
import Header from './components/Header'
import couponDisplay from './components/couponDisplay'
import menuHeader from './components/menu/menuHeader'
import menuFooter from './components/menu/menuFooter'
import Banner from './components/Banner'
import Content from './components/Content'
import Footer from './components/Footer'
import MenuDrawer from './components/drawers/menuDrawer/MenuDrawer'
import OrderDrawer from './components/drawers/orderDrawer/OrderDrawer'
import CouponDrawer from './components/drawers/couponDrawer/CouponDrawer'
import FeaturesDrawer from './components/drawers/featuresDrawer/FeaturesDrawer'
import MywayDrawer from './components/drawers/mywayDrawer/MywayDrawer'
import Menus from './components/menu/menus'
import MenusStatic from './components/menu/menus-static'
import ExpirationView from '@/components/Expiration'
import LoadingView from '@/components/Loading'
import ErrorView from '@/components/Error'
import InformationView from '@/components/Information'
import OrderItem from '@/components/orderitem/orderitem'
import OrderCoupons from '@/components/coupons/coupons'
import OrderTipping from '@/components/tipping/tipping'
import OrderPayment from '@/components/payments/payment'

import LocationHeader from '@/components/LocationHeader'
import LocationLogo from '@/components/LocationLogo'
import LocationInfo from '@/components/LocationInfo'
import MapView from '@/components/Map'
import normalizedImg from '@/components/normalized-img'
import translateComponent from '@/components/translate'
import wallpaper from '@/components/wallpaper'
import stylesheetrestaurant from '@/components/stylesheet-restaurant'



# Component registration
Vue.component 'order-header', Header
Vue.component 'order-coupon-display', couponDisplay
Vue.component 'order-menu-header', menuHeader
Vue.component 'order-menu-footer', menuFooter
Vue.component 'order-banner', Banner
Vue.component 'order-content', Content
Vue.component 'order-footer', Footer
Vue.component 'order-menu-drawer', MenuDrawer
Vue.component 'order-order-drawer', OrderDrawer
Vue.component 'order-coupon-drawer', CouponDrawer
Vue.component 'order-features-drawer', FeaturesDrawer
Vue.component 'order-myway-drawer', MywayDrawer
Vue.component 'order-menu-menus', Menus
Vue.component 'order-menu-static', MenusStatic
Vue.component 'expiration-view', ExpirationView
Vue.component 'loading-view', LoadingView
Vue.component 'error-view', ErrorView
Vue.component 'information-view', InformationView
Vue.component 'map-view', MapView
Vue.component 'order-item', OrderItem
Vue.component 'order-coupons', OrderCoupons
Vue.component 'order-tipping', OrderTipping
Vue.component 'order-payment', OrderPayment
Vue.component 'location-header', LocationHeader
Vue.component 'location-logo', LocationLogo
Vue.component 'location-info', LocationInfo
Vue.component 'normalized-img', normalizedImg
Vue.component 'translate', translateComponent
Vue.component 'wallpaper', wallpaper
Vue.component 'truncate', truncate
Vue.component 'stylesheet', stylesheet
Vue.component 'stylesheet-restaurant', stylesheetrestaurant

# V2 components.
import RegisterV2 from '@/components/v2/register'
import StartV2 from '@/components/v2/start'
import StylesheetV2 from '@/components/v2/stylesheet'
Vue.component 'start-v2', StartV2
Vue.component 'register-v2', RegisterV2
Vue.component 'stylesheet-v2', StylesheetV2

# Google Maps and AutoComplete
import { setOptions, importLibrary } from '@googlemaps/js-api-loader'
setOptions({ key: 'AIzaSyD6-qGdZj7_Nz7NTzJqrgCbycS9zr-OkZ8',  v: 'weekly' })
loadGoogleMaps = ->
  maps = await importLibrary('maps')
  places = await importLibrary('places')
  # Map the modern responses back to the legacy global objects
  window.google ?= {}
  window.google.maps ?= maps
  window.google.maps.places ?= places

import VueGoogleAutocomplete from 'vue-google-autocomplete'
Vue.component 'vue-google-autocomplete', VueGoogleAutocomplete
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use VueGoogleMaps

# Plugins
Vue.use Vuex
Vue.use Vuetify
Vue.use AsyncComputed;
# temporary diagnostic — log state at the moment of the crash
origSet = Vue.prototype.$set
Vue.prototype.$set = (target, key, val) ->
  if target is undefined
    console.error 'BAD $set on', @$options?.name or @$options?._componentTag,
      'key:', key,
      'asyncComputed entries:', Object.keys(@$data?._asyncComputed or {}),
      'destroyed:', @_isDestroyed, @_isBeingDestroyed,
      new Error('trace').stack
  origSet.call(this, target, key, val)
Vue.directive 'touch', {}
Vue.directive 'a11y-th-scope', a11yThScope
Vue.directive 'a11y-click', a11yClick
Vue.directive 'a11y-hidden', a11yHidden
Vue.use VueScrollTo


# Enable syncing the router and store
# Creates store.state.route{}
unsync = sync(store, router)

# Register filters
for k, v of filters
  Vue.filter k, v

# Config
Vue.config.productionTip = false

### eslint-disable no-new ###
do ->
  await loadGoogleMaps()
  V = new Vue(
    el: '#app'
    router: router
    store: store
    template: '<app/>'
    components:
      App: app
  )
